export default "__VITE_ASSET__6f7a3276__"